import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import getGigById from "../requests/getGigById";
import deleteGig from "../requests/deleteGig";

const ConfirmGigDeletion = () => {
  const history = useHistory();
  const { setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ gig, setGig ] = useState({
    date: "",
    venue: ""
  });

  const { tourId, gigId } = useParams();

  firebase.auth().onAuthStateChanged(function(firebaseUser) {
    if (firebaseUser) {
      setUser(firebaseUser);
      firebaseUser.getIdToken().then(token => {
        setToken(token);
        // console.log("JWT:", token);
      })
    } else {
      history.push("/login");
    }
  });

  useEffect(() => {
    if (token) {
      getGigById(token, tourId, gigId).then(response => {
        // console.log(response.data);
        if (response.status === 200) {
          setGig(response.data[0]);
        }
      });
    }
  }, [token, tourId, gigId]);

  const handleDeleteGig = (event) => {
    if (token) {
      deleteGig(token, tourId, gigId)
        .then((response) => {
          if (response.status === 204) {
            history.push(`/tour/${tourId}`)
          }
        });
    }
  };

  if (gig.date) {
    return (
      <div className="container center">
        <div className="confirm-delete">
          <h2 className="heading">Confirm deletion</h2>
          <h3>You have chosen to delete this Gig:</h3>
          <article className="toBeDeleted">
            <p>Date: <strong>{new Date(gig.date).toDateString()}</strong></p>
            <p>Venue: <strong>{gig.venue}</strong></p>
          </article>
          
          <p>Are you sure that you want to delete the Gig?</p>
          <p>Any Sales Items created as part of that Gig will also be deleted.</p>
          <p>This cannot be undone!</p>
          <div>
            <p><Link to={`/tour/${tourId}`} className="button-link">Take me back to the Tour Summary page</Link></p>
            <button
              type="button"
              className="form-button center"
              onClick={handleDeleteGig}
            >
              Confirm deletion of the {gig.venue} Gig
            </button>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container">
        <div className="unauthorised-deletion">
          <h2 className="heading">Unauthorised</h2>
          <p>You appear not to be authorised to delete this Gig.</p>
          <p>If you arrived here by clicking a link on the Tour Summary page then something went wrong between leaving that page and arriving here. Perhaps <Link to={`/tour/${tourId}`}>go back</Link> and try again.</p>
          <p>If you found your way here by some other means then you're wasting your time.</p>
          
        </div>
      </div>
    )
  }

};

export default ConfirmGigDeletion;
